import React, { useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import ContactModal from './ContactModal'; // Import ContactModal
import MobileNav from './MobileNav'; // Import MobileNav

const Layout = ({ children }) => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleContactClick = () => {
    setIsContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setIsContactModalOpen(false);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar onContactClick={handleContactClick} />
      <MobileNav onContactClick={handleContactClick} />
      <main className="flex-grow pt-24 pb-20 md:pt-24 md:pb-8">
        {children}
      </main>
      <Footer />
      <ContactModal isOpen={isContactModalOpen} onClose={handleCloseContactModal} />
    </div>
  );
};

export default Layout;